import request from '@/utils/request'

 // 查询销售预测列表
  export function apisalesForecastList (query) {
    return request({
      url: `/scp/salesForecast/list`,
      method: 'get',
      params: query
    })
  }
 // 新建发货预测
 export function apiCreateShipmentForecast (data) {
  return request({
    url: `/scp/salesForecast`,
    method: 'post',
    data: data
  })
}
 // 查询销售预测列表
 export function apiSalesForecastDetail (query) {
  return request({
    url: `/scp/salesForecastDetail/list`,
    method: 'get',
    params: query
  })
}
 // 删除销售预测明细
 export function apiDeleteSalesForecastDetail (data) {
  return request({
    url: `/scp/salesForecastDetail`,
    method: 'delete',
    data: data

  })
}
 // 修改销售预测明细
 export function apiUpdateSalesForecastDetail (data) {
  return request({
    url: `/scp/salesForecastDetail`,
    method: 'put',
    data: data
  })
}

 // 销售预测对比导出
 export function apiExportForecastContrast (data) {
  return request({
    url: `/scp/salesForecast/exportForecastContrast`,
    method: 'post',
    data: data
  })
}
 // 删除销售预测
 export function apiDeleteSalesForecast (data) {
  return request({
    url: `/scp/salesForecast`,
    method: 'delete',
    params: data
  })
}
